import { IconClose } from "@arco-design/web-react/icon";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import teamStore from "@/stores/team";
import userStore from "@/stores/user";
import "./index.less";

import LogoIcon from "@/assets/images/factory-logo.png";
import RightLogo from "@/assets/ai-factory/rights_logo.png";
import dayjs from "dayjs";

interface RightsDetailProps {
  visible: boolean;
  onClose: () => void;
}
const RightsDetail: React.FC<RightsDetailProps> = (props) => {
  const { visible, onClose } = props;

  // 参数
  const [boxVisible, setBoxVisible] = useState<boolean>(false);
  const [show, setShow] = useState<boolean>(false);
  // 算力信息
  const {
    total = 0,
    surplus = 0,
    expires_time,
    package_name = "",
  } = teamStore.packageInfo.packageList.find((item: any) => item.benefit_type === 24) || {};

  useEffect(() => {
    if (visible) {
      setBoxVisible(true);
      setTimeout(() => {
        setShow(true);
      }, 50);
    } else {
      setShow(false);
      setTimeout(() => {
        setBoxVisible(false);
      }, 300);
    }
  }, [visible]);
  if (!boxVisible) return null;
  return (
    <div className="rights-detail-box" onClick={onClose}>
      <div
        className="rights_details_card"
        style={{ bottom: show ? 0 : "calc(-100vh + 124px)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="rights_details_card_content">
          <img src={LogoIcon} className="rights_details_content_logo" />
          <IconClose className="rights_details_content_close" onClick={onClose} />
          <div className="rights_details_show_content">
            {/* 用户信息 */}
            <div className="show_content_user_info">
              <div
                className="user_info_avatar"
                style={{
                  background: userStore.userInfo?.avatar
                    ? `url(${userStore.userInfo?.avatar}) center/cover`
                    : userStore.userInfo?.avatar_color,
                }}
              >
                {!userStore.userInfo?.avatar && userStore.userInfo?.nickname?.slice(-2)}
              </div>
              <div className="user_info_data">
                <div className="user_info_data_name">{userStore.userInfo?.nickname}</div>
                {userStore.userInfo?.phone_number && (
                  <div className="user_info_data_phone">{userStore.userInfo?.phone_number}</div>
                )}
              </div>
            </div>
            {/* 我的权益 */}
            <div className="my_rights_details">
              <div className="my_rights_banner">
                <img src={RightLogo} className="my_rights_banner_logo" />
                <div className="my_rights_title">我的权益</div>
                <div className="my_rights_data">
                  <div className="my_rights_data_text">
                    <div>{expires_time}</div>
                    <div>到期时间</div>
                  </div>
                  <div className="my_rights_data_text">
                    <div>{package_name || "-"}</div>
                    <div>套餐名称</div>
                  </div>
                </div>
                <div className="my_rights_stats">
                  <div className="my_rights_stats_text">
                    <div>{total}</div>
                    <div>星算力总量</div>
                  </div>
                  <div className="my_rights_stats_text">
                    <div>{total - surplus}</div>
                    <div>已消耗星算力</div>
                  </div>
                  <div className="my_rights_stats_text">
                    <div>{surplus}</div>
                    <div>剩余星算力</div>
                  </div>
                </div>
              </div>
            </div>
            {/* 星算力消耗标准 */}
            <div className="rights_consume_title">星算力消耗标准</div>
            <div className="rights_consume_standard">
              <div className="rights_consume_standard_header" />
              <div className="rights_consume_content">
                {/* 合并表格线 */}
                <table border={1} className="rights_consume_table">
                  <thead>
                    <tr>
                      <th className="rights_consume_table_header1" rowSpan={2}>
                        视频大模型/类型
                      </th>
                      <th colSpan={3}>消耗单价（星算力/秒）</th>
                      <th rowSpan={2} className="table_header_support">
                        支持秒数
                      </th>
                    </tr>
                    <tr>
                      <th className="rights_consume_table_header2">文生视频</th>
                      <th className="rights_consume_table_header2">图生视频</th>
                      <th className="rights_consume_table_header2">参考视频</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>超能视频S2</td>
                      <td>23</td>
                      <td>23</td>
                      <td>23</td>
                      <td>8、12</td>
                    </tr>
                    {/* <tr>
                      <td>超能视频S2</td>
                      <td>50</td>
                      <td>50</td>
                      <td>50</td>
                      <td>6、8、12、15</td>
                    </tr> */}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default observer(RightsDetail);
